const initialState = {
    data: {
        checkLoading: false,
        checkErrorMessage: false,
        checkErrorMessageText: '',
        showHashModal: false, 
        transactionHash: ''
    }
} 

const transactionReducer = (state = initialState, action) => {
    if (action.type === 'SET_TRANSACTION'){
        return Object.assign({}, state, {
            data: action.payload
        })
    }

    if (action.type === 'CLEAR_TRANSACTION'){
        return Object.assign({}, state, {
            data: {
                checkLoading: false,
                checkErrorMessage: false,
                checkErrorMessageText: '',
                showHashModal: false, 
                transactionHash: ''
            }
        })
    }
  
    return state
}

export default transactionReducer


// WEBPACK FOOTER //
// ./src/user/transactionReducer.js